import React from 'react';
import { useLanguage } from '../context/LanguageContext';

export default function Leadership() {
  const { t } = useLanguage();

  const handleMouseMove = (e) => {
    const card = e.currentTarget;
    const rect = card.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    card.style.setProperty('--mouse-x', `${x}px`);
    card.style.setProperty('--mouse-y', `${y}px`);
  };

  return (
    <section className="section-wrapper reveal-on-scroll" id="gonulluluk">
      <div className="container">
        {/* Top: Volunteering Timeline */}
        <div className="section-header-neo">
          <div>
            <div className="neo-tag-pill">
              <span>[ {t.ui.volunteeringLabel} ]</span>
            </div>
            <h2 className="neo-section-title">{t.ui.volunteeringTitle}</h2>
          </div>
          <p className="neo-section-sub">{t.ui.volunteeringSubtitle}</p>
        </div>

        <div className="volunteer-neo-stack">
          {t.leadershipExperiences.map((exp, idx) => (
            <div
              key={idx}
              className="volunteer-neo-card spotlight-card"
              onMouseMove={handleMouseMove}
              style={{ animationDelay: `${idx * 0.1}s` }}
            >
              <div className="volunteer-neo-head">
                <div>
                  <h3 className="volunteer-neo-role">{exp.role}</h3>
                  <div className="volunteer-neo-org">{exp.organization}</div>
                </div>
                <span className="neo-tag-pill" style={{ color: '#ffffff', borderColor: '#3a4256' }}>
                  [{exp.period}]
                </span>
              </div>
              <p style={{ fontFamily: 'var(--font-mono)', color: 'var(--text-silver)', fontSize: '0.94rem', lineHeight: 1.65 }}>
                {exp.description}
              </p>
            </div>
          ))}
        </div>

        {/* Bottom: Education & Certifications */}
        <div id="egitim" style={{ paddingTop: '1.5rem' }}>
          <div className="credentials-neo-row">
            {/* Education Box */}
            <div className="cred-neo-card spotlight-card reveal-on-scroll" onMouseMove={handleMouseMove}>
              <h3 className="cred-neo-title">[ {t.ui.academicTitle} ]</h3>
              {t.educationList.map((edu, idx) => (
                <div
                  key={idx}
                  style={{
                    padding: '0.85rem 0',
                    borderBottom: idx === t.educationList.length - 1 ? 'none' : '2px solid #1e222d',
                  }}
                >
                  <div style={{ fontFamily: 'var(--font-display)', fontSize: '1rem', fontWeight: 800, color: '#ffffff' }}>
                    {edu.field} <span style={{ color: 'var(--accent-acid)', fontWeight: 700 }}>({edu.degree})</span>
                  </div>
                  <div style={{ fontFamily: 'var(--font-mono)', fontSize: '0.88rem', color: 'var(--text-secondary)', margin: '0.2rem 0' }}>
                    {edu.institution}
                  </div>
                  <div style={{ fontFamily: 'var(--font-mono)', fontSize: '0.8rem', color: 'var(--text-muted)' }}>
                    [{edu.period}]
                  </div>
                </div>
              ))}
            </div>

            {/* Certifications Box */}
            <div className="cred-neo-card spotlight-card reveal-on-scroll" onMouseMove={handleMouseMove}>
              <h3 className="cred-neo-title">[ {t.ui.certsTitle} ]</h3>
              {t.certifications.map((cert, idx) => (
                <div
                  key={idx}
                  style={{
                    padding: '0.85rem 0',
                    borderBottom: idx === t.certifications.length - 1 ? 'none' : '2px solid #1e222d',
                  }}
                >
                  <div style={{ fontFamily: 'var(--font-display)', fontSize: '0.98rem', fontWeight: 800, color: '#ffffff' }}>
                    {cert.title}
                  </div>
                  <div style={{ fontFamily: 'var(--font-mono)', fontSize: '0.84rem', color: 'var(--accent-acid)', marginTop: '0.2rem' }}>
                    {'//'} {cert.issuer}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
